import { DataSecurityLevel, EVENT_CATEGORY, EVENT_NAME, LATENCY, PAGE_NAME, PERFORMANCE_DETAILS, } from '@office-start/telemetry-types';
import { getFlattenedFieldName } from '@office-start/telemetry-utility';
import { getCurrentRouteItem, isRouteInitialized, logEvent, } from '../TelemetryService';
import { convertRouteToPage } from './logPageView';
/**
 * Logs Performance event with given properties. All Impression events will be stored into a single Kusto table `Office.Taos.Hub.Performance`.
 *  @param properties Properties pertaining to Performance event
 *                    - eventName: KnownPerfInstrumentationEvents;
 *                    - latency: number;
 *  @param securityThreshold DataSecurityLevel corresponds to Windows PlatformDataCollectionLevel which are ignored outside UWP.
 *
 *
 * e.g.
 *     logPerformance(
 *          {
 *              eventName: KnownPerfInstrumentationEvents.LastCDNScriptDownloaded,
 *              latency: 200,
 *         }
 *      );
 */
export function logPerformance(properties, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logEvent("Performance" /* Performance */, generateParams(properties), securityThreshold);
}
export function generateParams(properties) {
    var params = {};
    params[EVENT_CATEGORY] = "Performance" /* Performance */;
    params[EVENT_NAME] = properties.eventName;
    if (isRouteInitialized()) {
        params[PAGE_NAME] = convertRouteToPage(getCurrentRouteItem());
    }
    params[getFlattenedFieldName([PERFORMANCE_DETAILS, LATENCY])] = properties.latency.toString();
    return params;
}
//# sourceMappingURL=logPerformance.js.map